<div class="flex items-center justify-center dialog-header">
    {{type}} Batch
    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>
<div class="dialog-content" style="margin-top: -15px;">
    <form [formGroup]="batchForm" (ngSubmit)="onSubmit()" class="mt-4">
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4 gap-4">

            <!-- Batch Name (Full width) -->
            <div class="md:col-span-2">
                <label class="block mb-2">Batch Name<span class="text-red-500">*</span></label>
                <input type="text" pInputText class="w-full" formControlName="batch_name"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && batchForm.get('batch_name')?.errors }" />
                <small class="text-red-500"
                    *ngIf="isSubmitted && batchForm.get('batch_name')?.errors?.['required']">Batch
                    name is required</small>
            </div>

            <!-- Academic Year -->
            <div>
                <label class="block mb-2">Academic Year<span class="text-red-500">*</span></label>
                <p-select [options]="allAcademicYears" formControlName="academic_year_id"
                    placeholder="Select Academic Year"
                    
                    optionLabel="year_name"
                     optionValue="id" 
                    filterBy="label" class="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && batchForm.get('academic_year_id')?.errors }">
                </p-select>
                <small class="text-red-500"
                    *ngIf="isSubmitted && batchForm.get('academic_year_id')?.errors?.['required']">
                    Academic year is required</small>
            </div>

            <!-- Course -->
            <div>
                <label class="block mb-2">Course<span class="text-red-500">*</span></label>
                <p-select [options]="allCourses" formControlName="course_id" placeholder="Select Course"
                    optionLabel="name" optionValue="course_id"  filterBy="label" class="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && batchForm.get('course_id')?.errors }">
                </p-select>
                <small class="text-red-500" *ngIf="isSubmitted && batchForm.get('course_id')?.errors?.['required']">
                    Course is required</small>
            </div>

            <!-- Faculty -->
            <div>
                <label class="block mb-2">Faculty<span class="text-red-500">*</span></label>
                <p-select [options]="allUsers" formControlName="user_id" placeholder="Select Faculty" optionLabel="label"
                    optionValue="value"  class="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && batchForm.get('user_id')?.errors }">
                </p-select>
                <small class="text-red-500"
                    *ngIf="isSubmitted && batchForm.get('user_id')?.errors?.['required']">Faculty is required</small>
            </div>

            <!-- Maximum Students -->
            <div>
                <label class="block mb-2">Maximum Students<span class="text-red-500">*</span></label>
                <p-inputNumber formControlName="max_students" [min]="1" class="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && batchForm.get('max_students')?.errors }">
                </p-inputNumber>
                <small class="text-red-500"
                    *ngIf="isSubmitted && batchForm.get('max_students')?.errors?.['required']">Maximum students is
                    required</small>
            </div>

            <!-- Start Date -->
            <div>
                <label class="block mb-2">Start Date<span class="text-red-500">*</span></label>
                <p-calendar formControlName="start_date" dateFormat="dd/mm/yy" [showIcon]="true" class="w-full"
                appendTo="body"
                [style]="{ width: '100%' }"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && batchForm.get('start_date')?.errors }">
                </p-calendar>
                <small class="text-red-500"
                    *ngIf="isSubmitted && batchForm.get('start_date')?.errors?.['required']">Start date is
                    required</small>
            </div>

            <!-- End Date -->
            <div>
                <label class="block mb-2">End Date<span class="text-red-500">*</span></label>
                <p-calendar formControlName="end_date" dateFormat="dd/mm/yy" [showIcon]="true" class="w-full"
                appendTo="body"
                        [style]="{ width: '100%' }"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && batchForm.get('end_date')?.errors }">
                </p-calendar>
                <small class="text-red-500" *ngIf="isSubmitted && batchForm.get('end_date')?.errors?.['required']">End
                    date is required</small>
            </div>

            <!-- Status (Full width) -->
            <div class="md:col-span-2">
                <label class="block mb-2">Status<span class="text-red-500">*</span></label>
                <p-select [options]="statusOptions" formControlName="batch_status" placeholder="Select Status"
                    appendTo="body"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && batchForm.get('batch_status')?.errors }"
                    class="w-full">
                </p-select>
                <small class="text-red-500"
                    *ngIf="isSubmitted && batchForm.get('batch_status')?.errors?.['required']">Status is
                    required</small>
            </div>
        </div>

        <!-- Buttons -->
        <div class="flex justify-end gap-2 mt-4">
            <button pButton type="button" label="Cancel" class="p-button-outlined"
                (click)="handleCloseDialog()"></button>
            <button pButton type="submit" [label]="type" [loading]="btnLoading"></button>
        </div>
    </form>
</div>